const iconClasses = (object_type) => {
  let iconClassValue;
  switch (object_type) {
    case 'text/html':
      iconClassValue = ['fa-solid fa-link', 'link-icon text-info'];
      break;
    case 'application/pdf':
      iconClassValue = ['fa-solid fa-file-pdf', 'pdf-icon text-info'];
      break;
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      iconClassValue = ['fa-solid fa-file-doc', 'doc-icon text-info'];
      break;
    case 'application/msword':
      iconClassValue = ['fa-solid fa-file-doc', 'doc-icon text-info'];
      break;
    case 'text/plain':
      iconClassValue = ['fa-solid fa-file-lines', 'text-icon text-info'];
      break;
    case 'url':
      iconClassValue = ['fa-solid fa-link', 'link-icon text-info'];
      break;
    case 'text/csv':
      iconClassValue = ['fa-solid fa-file-csv', 'csv-icon text-info'];
      break;
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      iconClassValue = ['fa-solid fa-file-csv', 'csv-icon text-info'];
      break;
    case 'application/vnd.ms-excel':
      iconClassValue = ['fa-solid fa-file-csv', 'csv-icon text-info'];
      break;
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      iconClassValue = ['fa-solid fa-file-ppt', 'ppt-icon text-info'];
      break;
    case 'image/jpeg':
      iconClassValue = ['fa-solid fa-file-jpg', 'image-icon text-info'];
      break;
    case 'image/png':
      iconClassValue = ['fa-solid fa-file-png', 'image-icon text-info'];
      break;
    case 'image/gif':
      iconClassValue = ['fa-solid fa-file-gif', 'image-icon text-info'];
      break;
    case 'image/svg+xml':
      iconClassValue = ['fa-solid fa-file-svg', 'image-icon text-info'];
      break;
    case 'folder':
      iconClassValue = ['fa-solid fa-folder', 'folder-icon text-info'];
      break;
    case 'urllist':
      iconClassValue = ['fa-solid fa-sitemap', 'website-icon text-info'];
      break;
    default:
      iconClassValue = ['fa-solid fa-file', 'unknown-icon text-info'];
      break;
  }
  return iconClassValue;
};

const RECORD_KINDS = {
  URL: 'url',
  FILE: 'file',
  FOLDER: 'folder',
  HTML: 'text/html',
  SHAREPOINT: 'sharepoint',
  ADDITONALFOLDER: 'additionalfolder',
  URLLIST: 'urllist',
  SFTP: 'sftp',
  HUBSPOT: 'hubspot',
};

module.exports = {
  iconClasses,
  RECORD_KINDS,
};